module.exports = __webpack_public_path__ + "img/totop.d0fa0a05.png";